import { render, staticRenderFns } from "./PUserLogout.vue?vue&type=template&id=3a8456f0&"
import script from "./PUserLogout.vue?vue&type=script&lang=ts&"
export * from "./PUserLogout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports